import axios from "axios";

const BASE_URL = "https://pixabay.com/api/";
const API_KEY = "52982247-0d25e92a2d7c3074b601ee372";
const PER_PAGE = 9;

export async function getImagesByQuery(query, page = 1) {
  const params = {
    key: API_KEY,
    q: query,
    image_type: "photo",
    orientation: "horizontal",
    safesearch: true,
    page,
    per_page: PER_PAGE,
  };

  const response = await axios.get(BASE_URL, { params });
  return response.data;
}

export const PER_PAGE_COUNT = PER_PAGE;
